import { Box, MainTitle } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import React from "react";
import { StyleSheet } from "react-native";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import { useSelector } from "react-redux";
import CoachingGoalBar from "./CoachingGoalBar";
import { getCoachingGoals } from "@microdoing/shared/services/coaching/selectors";
import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";

const styles = StyleSheet.create({
  main: {
    marginTop: 15,
    width: wp("90%"),
  },
});

const CoachingGoals = () => {
  const language = useSelector(getLanguage);
  const coachingGoals = useSelector(getCoachingGoals);

  return (
    <AnimatedBox style={styles.main}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
      >
        <MainTitle variant="l3-bold">{i18n.t("coaching-roadmap")}</MainTitle>
      </Box>
      {coachingGoals.map(goal => (
        <CoachingGoalBar
          key={goal._id}
          goalDone={goal.doneSteps?.length}
          goalTitle={selectLanguage({ text: goal?.skill?.label, language })}
          goalNumber={goal.goalNumber}
        />
      ))}
    </AnimatedBox>
  );
};

export default CoachingGoals;
